import { useSupportSettingsPageNavigator } from "@-/dev.improve.haniverse.routes.nav.app.settings.support.navigator";
import { ScrollView } from "@-/com.npmjs.react-native";
import { SupportSettingsOptions } from "#support-settings-options";

export function SupportSheetIndex() {
  const supportNavigator = useSupportSettingsPageNavigator();
  return (
    <ScrollView className="flex-1" contentContainerClassName="pb-6">
      <SupportSettingsOptions onAboutPress={() => supportNavigator.navigate.mutate("about")} />
    </ScrollView>
  );
}
